import React from 'react';
import LoadingSpinner from './LoadingSpinner';

export default function OperatorConsoleFlow() {
  return <LoadingSpinner loadingText={`Sending Message to Patient`} />;
}
